import React from 'react';
import { cn } from '../lib/utils';
interface SectionProps {
  id: string;
  title?: React.ReactNode;
  children: React.ReactNode;
  className?: string;
}
export function Section({
  id,
  title,
  children,
  className
}: SectionProps) {
  return <section id={id} className={cn('reveal-section w-full py-24 md:py-32 px-6 md:px-12 lg:px-24 flex flex-col items-center', className)} data-id="element-58">
      <div className="w-full max-w-3xl" data-id="element-59">
        {title && <h2 className="text-3xl md:text-4xl font-light tracking-wide mb-12 text-foreground" data-id="element-60">
            {title}
          </h2>}
        <div className="text-base md:text-lg leading-[1.8] text-muted-foreground space-y-6 font-light" data-id="element-61">
          {children}
        </div>
      </div>
    </section>;
}